var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__ds",
    x1: 203.34,
    y1: 155.48,
    x2: 286.87,
    y2: 155.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m266.97,146.54l-40.31,40.31v-90.88c0-6.43-5.23-11.66-11.66-11.66s-11.66,5.23-11.66,11.66v115.79c0,.56.05,1.1.13,1.64-.48,3.49.61,7.16,3.29,9.84,2.27,2.27,5.26,3.41,8.25,3.41s5.97-1.14,8.25-3.41l60.22-60.22c4.55-4.55,4.55-11.94,0-16.49s-11.95-4.55-16.49,0Z",
    fill: "url(#clock_svg__ds)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m342.39,87.61c-17.19-17.2-37.25-30.51-59.6-39.58-21.59-8.75-44.4-13.19-67.79-13.19s-46.2,4.44-67.79,13.19c-22.36,9.06-42.41,22.38-59.6,39.58-17.19,17.19-30.51,37.25-39.58,59.6-8.75,21.59-13.19,44.39-13.19,67.79s4.44,46.2,13.19,67.79c9.06,22.36,22.38,42.41,39.57,59.6,17.2,17.2,37.25,30.51,59.6,39.58,21.59,8.75,44.4,13.19,67.79,13.19s46.2-4.44,67.79-13.19c22.35-9.06,42.41-22.38,59.6-39.57,17.19-17.19,30.51-37.25,39.57-59.6,8.75-21.59,13.19-44.39,13.19-67.79s-4.44-46.2-13.19-67.79c-9.07-22.36-22.38-42.41-39.57-59.6Zm-127.39,284.22c-20.38,0-40.23-3.86-59.02-11.48-19.45-7.89-36.9-19.48-51.88-34.45-14.97-14.97-26.57-32.43-34.45-51.88-7.62-18.79-11.48-38.65-11.48-59.02,0-20.37,3.86-40.23,11.48-59.02,7.89-19.45,19.48-36.9,34.45-51.88,14.98-14.97,32.43-26.57,51.88-34.45,18.79-7.62,38.65-11.48,59.02-11.48s40.23,3.86,59.02,11.48c19.45,7.89,36.9,19.48,51.88,34.45,14.97,14.98,26.57,32.43,34.45,51.88,7.62,18.79,11.48,38.65,11.48,59.02s-3.86,40.23-11.48,59.02c-7.89,19.45-19.48,36.9-34.45,51.88s-32.43,26.56-51.88,34.45c-18.79,7.62-38.65,11.48-59.02,11.48Z",
    fill: "#f7f7f7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.51d375ffa09752ddcf09b843b6105263.svg";
export { ForwardRef as ReactComponent };